import { Table, flexRender } from '@tanstack/react-table';

import Filter from '../Filter';

export interface LayoutTableHeaderProps {
  table: Table<any>;
}

const LayoutTableHeader: React.FunctionComponent<LayoutTableHeaderProps> =
  function ({ table }) {
    const headerGroups = table.getHeaderGroups();
    return (
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id} colSpan={header.colSpan}>
                {header.isPlaceholder ? null : (
                  <>
                    <div
                      {...{
                        className: `flex flex-row justify-center whitespace-nowrap ${
                          header.column.getCanSort()
                            ? 'cursor-pointer select-none'
                            : ''
                        }`,
                        onClick: header.column.getToggleSortingHandler(),
                        onKeyDown: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                      {{
                        asc: ' 🔼',
                        desc: ' 🔽',
                      }[header.column.getIsSorted() as string] ?? null}
                    </div>
                    {header.column.getCanFilter() ? (
                      <div>
                        <Filter table={table} column={header.column} />
                      </div>
                    ) : null}
                  </>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
    );
  };

export default LayoutTableHeader;
